import { combineReducers } from '@reduxjs/toolkit';
import authReducer from "../find-a-job/reducers/authReducer"
import projectReducer from "../find-a-job/reducers/projectReducer"
const findAJobReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
});

export default findAJobReducer;

